import type { ReactElement } from 'react';

/** The person mark on the Join Ember pill and the signed-out account circle (Landing nav, a light's page toolbar). */
export function ProfileGlyph(): ReactElement {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden><circle cx="12" cy="7.5" r="3.5" /><path d="M4.5 21a7.5 7.5 0 0 1 15 0" /></svg>;
}
